<script setup>
import AlertsPage from '@/components/AlertsPage.vue';

</script>

<template>
  <Suspense>
    <AlertsPage />
  </Suspense>
</template>
